module.exports = __webpack_public_path__ + "img/kia-Worth.32aa6d11.png";